// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxcite_header__1uC3e","info":"Component-pepxcite_info__2aXWU"};